import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthenticationService } from '@dvm-monorepo/frontend/services/authentication.service';
import { SpinnerComponent } from '@dvm-monorepo/ui/components/spinner.component';

@Component({
    imports: [RouterModule, SpinnerComponent],
    selector: 'dvm-root',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (!authenticationService.isAuthenticating()) {
            <router-outlet />
        } @else {
            <div class="min-h-screen flex items-center justify-center px-8">
                <ui-spinner />
            </div>
        }
    `
})
export class App {
    public readonly authenticationService = inject(AuthenticationService);
}
